__turbopack_context__.v({
  "className": "landingmono_f1818da8-module__eB2Vca__className",
  "variable": "landingmono_f1818da8-module__eB2Vca__variable",
});
